import { KYC_ENABLED } from '@sense/shared';
import { Cpu, Croissant, ShoppingBasket, Shirt, Store, Wheat, type LucideIcon } from 'lucide-react';
import type { BusinessType } from './session';

export const BUSINESS_TYPES: Array<{ id: BusinessType; label: string; icon: LucideIcon }> = [
  { id: 'supermarket', label: 'Supermarket', icon: ShoppingBasket },
  { id: 'grocery', label: 'Grocery', icon: Wheat },
  { id: 'fashion', label: 'Fashion', icon: Shirt },
  { id: 'electronics', label: 'Electronics', icon: Cpu },
  { id: 'bakery', label: 'Bakery', icon: Croissant },
  { id: 'other', label: 'Other', icon: Store },
];

const ALL_SETUP_STEPS = [
  { id: 'details', label: 'Store details' },
  { id: 'business', label: 'Business info' },
  { id: 'bank', label: 'Bank details' },
  { id: 'hours', label: 'Delivery & hours' },
  { id: 'kyc', label: 'KYC documents' },
] as const;
export type SetupStep = (typeof ALL_SETUP_STEPS)[number]['id'];
export const SETUP_STEPS = ALL_SETUP_STEPS.filter((s) => KYC_ENABLED || s.id !== 'kyc');
/** Saved steps that are still shown (a store may have saved KYC before it was hidden). */
export const setupDone = (steps: string[]) => SETUP_STEPS.filter((s) => steps.includes(s.id)).length;

export const INDIAN_STATES: Array<[string, string]> = [
  ['AN', 'Andaman & Nicobar'], ['AP', 'Andhra Pradesh'], ['AR', 'Arunachal Pradesh'], ['AS', 'Assam'], ['BR', 'Bihar'], ['CH', 'Chandigarh'],
  ['CT', 'Chhattisgarh'], ['DN', 'Dadra & Nagar Haveli and Daman & Diu'], ['DL', 'Delhi'], ['GA', 'Goa'], ['GJ', 'Gujarat'], ['HR', 'Haryana'],
  ['HP', 'Himachal Pradesh'], ['JK', 'Jammu & Kashmir'], ['JH', 'Jharkhand'], ['KA', 'Karnataka'], ['KL', 'Kerala'], ['LA', 'Ladakh'],
  ['LD', 'Lakshadweep'], ['MP', 'Madhya Pradesh'], ['MH', 'Maharashtra'], ['MN', 'Manipur'], ['ML', 'Meghalaya'], ['MZ', 'Mizoram'],
  ['NL', 'Nagaland'], ['OR', 'Odisha'], ['PY', 'Puducherry'], ['PB', 'Punjab'], ['RJ', 'Rajasthan'], ['SK', 'Sikkim'], ['TN', 'Tamil Nadu'],
  ['TG', 'Telangana'], ['TR', 'Tripura'], ['UP', 'Uttar Pradesh'], ['UT', 'Uttarakhand'], ['WB', 'West Bengal'],
];

/** Store status chips (platform console, store switcher). */
export const STATUS_STYLE: Record<string, string> = {
  pending: 'bg-t-amber text-t-amber-fg', approved: 'bg-t-green text-forest-800', paused: 'bg-t-blue text-t-blue-fg',
  rejected: 'bg-t-red text-danger', deactivated: 'bg-paper text-muted',
};
